/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ distance: NonNullable<unknown> }} Item_Stats_AgoInputs */

const he_item_stats_ago = /** @type {(inputs: Item_Stats_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`לפני ${i?.distance}`)
};

const en_item_stats_ago = /** @type {(inputs: Item_Stats_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.distance} ago`)
};

/**
* | output |
* | --- |
* | "{distance} ago" |
*
* @param {Item_Stats_AgoInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const item_stats_ago = /** @type {((inputs: Item_Stats_AgoInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_AgoInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_ago(inputs)
	return en_item_stats_ago(inputs)
});